module.exports = __webpack_public_path__ + "img/highNoon.53c67852.png";